module.exports = __webpack_public_path__ + "static/WEDDING E&M-23-a48f49f029c58bebe968e856407b99fc.jpg";